module.exports = __webpack_public_path__ + "img/no-content-search.156909b1.svg";